// Libraries
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/brands";

// Global
import "./global/load";
import "./global/animations";
import "./global/keywords";

//Components
import "./components/nav";
import "./components/lightbox";
import "./components/filter-hover";

//Pages
import "./pages/home";
import "./pages/barristers";
import "./pages/cv";
import "./pages/clerks";
